import React from 'react';
import { Paper, Typography, Stack, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function CardLink({ to, title, description }) {
  return (
    <Box component={RouterLink} to={to} sx={{ textDecoration: 'none', display: 'block', height: '100%' }}>
      <Paper sx={{ p: 2, height: '100%', cursor: 'pointer', transition: 'box-shadow 0.2s, border-color 0.2s', '&:hover': { boxShadow: 4, borderColor: 'primary.main' } }}>
        <Stack spacing={1}>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary">{description}</Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
